export const SMART_RECOMMENDATION_ACTIONS = {
    FETCH_SMART_RECOMMENDATION_SUCCESS : 'FETCH_SMART_RECOMMENDATION_SUCCESS'
}
